(() => {
  const container = document.querySelector('.shopify-policy__container');
  const body = container?.querySelector('.shopify-policy__body');
  if (!body || container.querySelector('[data-slich-reading-nav]')) return;
  const headings = [...body.querySelectorAll('h2')];
  if (headings.length < 4) return;

  const nav = document.createElement('nav');
  nav.className = 'slich-reading-nav';
  nav.dataset.slichReadingNav = '';
  nav.setAttribute('aria-label', 'Sommaire de cette page');
  const disclosure = document.createElement('details');
  disclosure.open = window.matchMedia('(min-width: 990px)').matches;
  const summary = document.createElement('summary');
  summary.textContent = 'Dans cette page';
  const list = document.createElement('ul');
  headings.forEach((heading, index) => {
    if (!heading.id) {
      let id = `slich-lecture-${index + 1}`;
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    }
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${encodeURIComponent(heading.id)}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });
  disclosure.append(summary, list);
  nav.append(disclosure);
  body.before(nav);
  container.classList.add('slich-reading-layout');
})();
